module.exports = __webpack_public_path__ + "static/heroslider-2-ae9209b7953a48db1ea58a2adb04d172.jpeg";